import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import WorkIcon from "@mui/icons-material/Work";
import CampaignIcon from "@mui/icons-material/Campaign";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { postRequest } from "../../api/apiServices";
import { jobsList } from "../../api/apiList";
import ShimmerEffect from "../../utils/ShimmerEffect";
import "../../styles/Listing/listing-premium.css";

interface JobListItem {
  id: number;
  jobTitle: string;
  workingLocation?: string;
  reference_number?: string;
}

const CampaignJobPicker: React.FC = () => {
  const navigate = useNavigate();
  const [jobs, setJobs] = useState<JobListItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchJobs = async () => {
      setLoading(true);
      try {
        const response = await postRequest(jobsList, {
          page: 1,
          limit: 100,
          search: "",
          searchColumns: ["jobTitle"],
        });
        setJobs(response?.data?.data?.jobs || []);
      } catch {
        setJobs([]);
      } finally {
        setLoading(false);
      }
    };

    fetchJobs();
  }, []);

  return (
    <Box className="listing-page">
      <button
        type="button"
        className="listing-back-btn"
        onClick={() => navigate("/campaigns")}
      >
        <ArrowBackIcon sx={{ fontSize: 18 }} />
        Back to campaigns
      </button>

      <Box className="listing-hero">
        <Box className="listing-hero-inner">
          <Box>
            <Box className="listing-hero-badge">
              <CampaignIcon sx={{ fontSize: 14 }} />
              New Campaign
            </Box>
            <h1 className="listing-hero-title">Select a Job Specification</h1>
            <p className="listing-hero-subtitle">
              Campaigns must be created from an approved job with vacancy text.
              Choose a job below to continue.
            </p>
          </Box>
        </Box>
      </Box>

      {loading ? (
        <ShimmerEffect />
      ) : jobs.length === 0 ? (
        <Box className="listing-empty">
          <Box className="listing-empty-icon">
            <WorkIcon />
          </Box>
          <h2 className="listing-empty-title">No Job Specifications Found</h2>
          <p className="listing-empty-text">
            Create a job specification before starting a campaign.
          </p>
          <button
            type="button"
            className="listing-cta-btn"
            style={{ marginTop: 20 }}
            onClick={() => navigate("/jobs")}
          >
            Go to Jobs
          </button>
        </Box>
      ) : (
        <Box className="listing-list">
          {jobs.map((job) => (
            <Box key={job.id} className="listing-card">
              <Box className="listing-card-body">
                <Box className="listing-card-info">
                  <p className="listing-card-title">{job.jobTitle}</p>
                  {job.workingLocation && (
                    <Box className="listing-meta-row">
                      <span className="listing-meta-chip">
                        <LocationOnIcon />
                        {job.workingLocation.split(",")[0]}
                      </span>
                    </Box>
                  )}
                </Box>
                <button
                  type="button"
                  className="listing-cta-btn"
                  onClick={() => navigate(`/campaigns/create/${job.id}`)}
                >
                  <CampaignIcon sx={{ fontSize: 18 }} />
                  Create Campaign
                </button>
              </Box>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default CampaignJobPicker;
